export default {
  init() {
    $('.open-menu').on('click', (e) => {
      const menuOpened = $('.espace-adherent-menu-responsive').height() > 50
      if(menuOpened){
        $('.espace-adherent-menu-responsive').css({ height: 50 });
        $('.open-menu').css({ transform: 'rotate(0deg)' });
      } else {
        const height = $('.espace-adherent-menu-responsive-content').height();
        $('.espace-adherent-menu-responsive').css({ height: height + 50 + 10 });
        $('.open-menu').css({ transform: 'rotate(90deg)' });
      }
    })

    setTimeout(() => {
      $('.notification-success').hide()
    }, 3000);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js